import '@/localization/i18n';

import React from 'react';
import Helmet from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { Provider } from 'react-redux';
import { RouterProvider } from 'react-router-dom';

import MapInit from '@/components/Map/MapInit';
import SnackProvider from '@/providers/SnackProvider';
import ThemeProvider from '@/providers/ThemeProvider';
import { store } from '@/store/store';

import router from './router';

const App = () => {
  const { t } = useTranslation();

  return (
    <MapInit>
      <Provider store={store}>
        <Helmet
          defaultTitle={t('components.App.defaultTitle')}
          titleTemplate={`%s - ${t('components.App.defaultTitle')}`}
        />
        <SnackProvider>
          <ThemeProvider>
            <RouterProvider router={router} />
          </ThemeProvider>
        </SnackProvider>
      </Provider>
    </MapInit>
  );
};

export default App;
